const LSRoutes ={
    Login:"/login",
    Dashboard:page=>{return page ? `/panel/${page}` : `/panel/dashboard`}    
}

export  {LSRoutes};